angular.module('app.point.coupons', ['ngRoute', 'ngResource', 'angular-jwt', 'ngFileUpload', 'bw.paging', 'uiGmapgoogle-maps'])
.config(['$routeProvider', function routerProvider($routeProvider) {
  $routeProvider.when('/point/coupons', {
    template: require('./coupons.html'),
    controller: 'pointCouponsCtrl',
  }).when('/point/coupons/add', {
    template: require('./add.html'),
    controller: 'pointCouponsAddCtrl',
  });
}])
.controller('pointCouponsCtrl', ($rootScope, $translate, $scope, $resource, $route, $location, $cookies, $window, AuthService, envService) => {
  $rootScope.mainmenu = 'coupons';
  $rootScope.menu = 'point';
  const APIURL = envService.read('apiUrl');
  if (!AuthService.isAuthenticated()) {
    $location.path('/login');
    return;
  }

  $scope.total_count = 0;
  $scope.query = '';

  $resource(`${APIURL}/admin/point/coupons`).get({ q: $scope.query }, (data) => {
    $scope.coupons = data.coupons;
    $scope.total_count = data.total_count;
    console.log(data);
  }, (err) => {
    console.error(err);
    if (err.data && err.data.msg) {
      alert(err.data.msg);
    } else {
      alert($translate.instant('알수 없는 에러 입니다.'));
    }
  });

  $scope.paging = function funcPaging(page) {
    $resource(`${APIURL}/admin/point/coupons`).get({ page: page - 1, q: $scope.query },
            (data) => {
              console.log(data);
              $scope.coupons = data.coupons;
              $scope.total_count = data.total_count;
            }, (err) => {
              console.error(err);
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
  };

  $scope.delete = function funcDelete(coupon) {
    if (!confirm($translate.instant('정말로 삭제하시겠습니까?'))) {
      return;
    }
    $resource(`${APIURL}/admin/point/coupons/:coupon_id`, { coupon_id: coupon.ID }).delete(
            () => {
              alert($translate.instant('삭제되었습니다'));
              $scope.coupons.splice($scope.coupons.indexOf(coupon), 1);
            }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };

  $scope.showGroupCoupons = function showGroupCoupons(coupon) {
    console.log(coupon);
    $resource(`${APIURL}/admin/point/coupons/${coupon.ID}`).get((data) => {
      console.log(data);
      $scope.group_coupons = data.coupons;
      jQuery('#modal-coupon').modal('show');
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };
})
.controller('pointCouponsAddCtrl', ($rootScope, $translate, $scope, $resource, $route, $location, $cookies, $window, $timeout, AuthService, envService) => {
  $rootScope.mainmenu = 'coupons';
  $rootScope.menu = 'point';

  const APIURL = envService.read('apiUrl');
  if (!AuthService.isAuthenticated()) {
    $location.path('/login');
    return;
  }

  $scope.newcoupon = { PRICE: 50000, COUNT: 1, COMMENT: '' };
  $scope.selectedUsers = [];

  $scope.submit = function submit() {
    if ($scope.newcoupon.PRICE === undefined) {
      alert($translate.instant('가격을 입력해주세요.'));
      return;
    }
    if (isNaN(parseInt($scope.newcoupon.PRICE, 10))) {
      alert($translate.instant('올바른 가격을 입력해주세요.'));
      return;
    }
    if ($scope.newcoupon.COMMENT.length < 1) {
      alert($translate.instant('코멘트를 입력해주세요.'));
      return;
    }
    $resource(`${APIURL}/admin/point/coupons`).save($scope.newcoupon,
            (data) => {
              console.log(data);
              alert($translate.instant('쿠폰이 발급되었습니다.'));
              $location.path('/point/coupons');
            }, (err) => {
              console.error(err);
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
  };
});



// WEBPACK FOOTER //
// ./src/app/point/coupons.js